import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Collar } from '@types';
import { CacheService } from 'app/core/services/cache.service';
import { UserService } from 'app/core/user/user.service';
import { SharedService } from 'app/shared/shared.service';
import { combineLatest, from, Observable, switchMap, take } from 'rxjs';


@Injectable({
    providedIn: 'root'
})
export class HoleListResolver implements Resolve<any> {
	sharedService = inject(SharedService)
	cacheService = inject(CacheService)
	userService = inject(UserService)

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Resolver
     *
     * @param route
     * @param state
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Collar[]>
    {
        return combineLatest([
            from(this.cacheService.getFormFields()),
            this.userService.user$
        ]).pipe(
            take(1),
            switchMap(([formFields, user]) => {
                const params: any = {};
                const status = 'all';
                const drillHoleType = 'all';

                if (status !== 'all') params.status = status;
                if (drillHoleType !== 'all') params.drillHoleType = drillHoleType;

                return this.sharedService.getEntities<Collar>('collar/all');
            })
        );
    }
}

